// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.hero-video-container video {
  position: absolute;
  object-fit: cover;
  object-position: var(--hero-video-position);
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
}`, "",{"version":3,"sources":["webpack://./src/components/blocks/Hero/HeroVideo/HeroVideo.scss"],"names":[],"mappings":"AACI;EACI,kBAAA;EACA,iBAAA;EACA,2CAAA;EACA,WAAA;EACA,YAAA;EACA,MAAA;EACA,OAAA;AAAR","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
